import CloseRounded from "@mui/icons-material/CloseRounded";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useMemo } from "react";
import Flx from "../layout/Flx";
import Htag from "../typography/Htag";
import ModalContent from "./shared/ModalContent";
const shadow1 = "rgba(0, 0, 0, .1)";
const mediaInnerBorder = "rgba(0, 0, 0, .1)";
const shadowInset = "rgba(255, 255, 255, .5)";

const SideDrawer = ({
  show,
  onClose,
  title,
  // Optional second line under the title — use it for the entity the drawer is
  // scoped to ("Members" / "Borrower Submission Notifications") instead of
  // packing both into `title` with a dash.
  subtitle,
  children,

  drawerWidth = "800px",
  suppressBodyPadding,
  suppressBodyOverflow,
  bodySx,

  anchor = "right",

  headerSx,
}) => {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <>
      <Drawer
        anchor={anchor}
        open={show}
        onClose={onClose}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            // position: position,
            boxSizing: "border-box",
          },
        }}
      >
        <Header
          sx={headerSx}
          title={title}
          subtitle={subtitle}
          onClose={handleClose}
        />
        <Body
          suppressBodyPadding={suppressBodyPadding}
          suppressBodyOverflow={suppressBodyOverflow}
          sx={bodySx}
        >
          {children}
        </Body>
      </Drawer>
    </>
  );
};

const Header = ({ title, subtitle, onClose, sx }) => {
  const styles = useMemo(() => {
    let sty = {
      position: "relative",
      overflow: "hidden",
      flexGrow: 0,
      flexShrink: 0,
      boxShadow: `0 1px 2px ${shadow1},0 -1px ${mediaInnerBorder} inset,0 2px 1px -1px ${shadowInset} inset`,
    };

    return {
      ...sty,
      ...sx,
    };
  }, [sx]);
  return (
    <>
      <ModalContent sx={styles}>
        <Flx fw jb ac>
          <Flx column g={0} sx={{ minWidth: 0 }}>
            <Htag sx={{ lineHeight: 1.4 }} h2>
              {title}
            </Htag>
            {subtitle && (
              <Box
                sx={{
                  fontSize: 13.5,
                  lineHeight: 1.3,
                  color: "text.secondary",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {subtitle}
              </Box>
            )}
          </Flx>

          <Flx ac g={0}>
            <Tooltip title={"Close"} arrow>
              <IconButton
                color="primary"
                size="small"
                sx={{ marginLeft: 1, borderRadius: "4px" }}
                onClick={() => onClose(false)}
              >
                <CloseRounded />
              </IconButton>
            </Tooltip>
          </Flx>
        </Flx>
      </ModalContent>
    </>
  );
};

const Body = ({ children, suppressBodyPadding, suppressBodyOverflow, sx }) => {
  const styles = useMemo(() => {
    let sty = { position: "relative" };

    if (suppressBodyPadding) {
      sty = { ...sty, padding: 0 };
    }
    if (suppressBodyOverflow) {
      sty = { ...sty, overflow: "hidden" };
    }
    return {
      ...sty,
      ...sx,
    };
  }, [sx, suppressBodyPadding, suppressBodyOverflow]);
  return (
    <>
      <ModalContent sx={styles}>{children}</ModalContent>
    </>
  );
};

export default SideDrawer;
